import { useWstEth2StEthRate } from './useWstEth2StEthRate'

export const useWithdrawalRate = (isSelectedStETH: boolean) => {
  const { rate, isValidating } = useWstEth2StEthRate('1')
  return {
    rate: isSelectedStETH ? '1' : rate,
    isValidating: isSelectedStETH ? false : isValidating,
  }
}
